import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import Util from './../../../shared/util/util';
import LRCopy from './../booking/LRCopy';
import Report from './../../../report/services/report.service';
import CONSTANT from './../../../shared/constants/constant';
import {Validator} from 'vee-validate';
import Printd from 'printd';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';

export default {
  name:'printAWB',
  components:{
    CustomExpandableTable,
    VueElementLoading,
    LRCopy,
    Treeselect
  },
  data:function(){
    return{
      isLoading: false,
      showdetails: false,
      AWBNumber: '',
      noofcopies: 1,
      pagelist:[{'id':1,'label':'AWB Set (4 copies)'},{'id':2,'label':'Extra Copy'}],
      validatedawb:[],
      printMultipleAwbs:[],
	    hubid:"",
      userid:"",
      useremail:"",
      printlr:false
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.hubname = userdetail.currentHubName;
  	this.hubid = userdetail.hubID[0];
  	this.userid = userdetail.userid;
  	this.useremail = userdetail.email;
  },
  methods:{
     isIntegerOnly: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode == 13) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
    selectNoOfCopies(data){
      if(data){
        this.noofcopies = data.id;
        this.printlr = true;
      }else{
        this.printlr = false;
      }
    },
    async searchAWB(){
      try{
        this.validatedawb = [];
        this.printMultipleAwbs = [];
        let printMultipleAwbsLogs = [];
		    let dt = moment().tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss');
        this.$validator.validateAll().then( async (result) => {
          if(result){
            this.isLoading=true;
            let awbnumbers = this.AWBNumber.split(/[,]+/);
            let newawbnumbers = awbnumbers.filter(function (n) { return n !== "" });
            let inputPayload ={};
            let payload = {
              'awb': newawbnumbers
            }
            let result = await TripServices.getAWBDetailsForLRCopy(payload);

            if(result.data.code == 200){
              let awbdetails = result.data.data.awbdetails;
              let hubdetails = result.data.data.hubdetails;
              if(awbdetails.length > 0){
                for(const item of awbdetails){
                  let pickupTime = "";
                  if(item.PickupDetails.SlotsTime.From){
                     pickupTime=item.PickupDetails.SlotsTime.From.slice(0,2)+":"+ item.PickupDetails.SlotsTime.From.slice(2,4)
                  }

                  let originhub;
                  let destinationhubs;
                  hubdetails.forEach(hubitem=>{
                    if(item.OriginHubID==hubitem.HubID){
                      originhub=hubitem.HubName;
                    }
                    if(item.DestinationHubId==hubitem.HubID){
                      destinationhubs=hubitem.HubName
                    }
                  });

                  //get sku dimensions list
                  let dim = [];
                  let qty = [];
                  for(let i=0; i<5; i++){
                    if(item.enabledimensionvisibilitylrcopy && item.SKUDetails && item.SKUDetails[i] && item.SKUDetails[i].BoxDimensions && item.clienttype!="SalesFranchise"){
                      dim.push(item.SKUDetails[i].BoxDimensions);
                    }else{
                      dim[i] = "";
                    }
                    if(item.enabledimensionvisibilitylrcopy && item.SKUDetails && item.SKUDetails[i] && item.SKUDetails[i].NoOfBoxes && item.clienttype!="SalesFranchise"){
                      qty.push(item.SKUDetails[i].NoOfBoxes);
                    }else{
                      qty[i] = "";
                    }
                  }

        				  // key is mapped with CargoLRCopy API Key
        				  let awbCustomiseData = {
          					"referenceno":item.referenceno,
          					"ConsigneeCode":item.DropDetails.Addresses[0].ConsigneeCode,
          					"consigneename":item.DropDetails.Addresses[0].Name,
          					"ConsigneePOC":item.DropDetails.Addresses[0].Attn,
          					"PickupLocation":item.PickupDetails.Addresses[0].Name,
          					"ClientReferenceNo":item.ClientReferenceNo,
          					"InvoiceNumber":item.InvoiceNumber,
          					"ebn":item.ebn,
          					"ConsigneeAddress":item.DropDetails.Addresses[0].Address,
          					"PickupItemCount":(item.vtcamount)?item.vtcamount:""
        				  }
                  let awbdata = {
                      "awbnumber":item.parentawb,
                      "originhub":null,
                      "originhubid":item.OriginHubID,
                      "destinationhubs":null,
                      "destinationhubid":item.DestinationHubId,
                      "clientid":item.ClientID,
                      "clientbusinessacountid":item.clientbusinessacountid,
                      "reliancesecondaryclient":item.reliancesecondaryclient,
                      "businessaccountname":item.BusinessAccountName,
                      "pickupname":item.PickupDetails.Addresses[0].Name,
                      "pickupaddress":item.PickupDetails.Addresses[0].Address,
                      "pickupcity":item.PickupDetails.Addresses[0].City,
                      "pickuppincode":item.PickupDetails.Addresses[0].PinCode,
                      "pickupmobile":item.PickupDetails.ContactDetails[0].PhoneNo,
                      "pickupgst":item.PickupDetails.Addresses[0].TINNo,
                      "pickupemail":item.PickupDetails.Addresses[0].EmailID,
                      "requestedpickupdate":Util.displayDateOnlyFormat(item.PickupDetails.PickupSlotsDate),
                      "requestedpickuptimefrom":pickupTime,
                      "consingneecode":item.DropDetails.Addresses[0].ConsigneeCode,
                      "consingneename":item.DropDetails.Addresses[0].Name,
                      "consingneeattn":item.DropDetails.Addresses[0].Attn,
                      "consingneeaddress":item.DropDetails.Addresses[0].Address,
                      "consingneecity":item.DropDetails.Addresses[0].City,
                      "destinationpincode":item.DropDetails.Addresses[0].PinCode,
                      "consingneemobile":item.DropDetails.ContactDetails[0].PhoneNo,
                      "consingneecsttin":item.DropDetails.Addresses[0].TINNo,
                      "consingneeemail":item.DropDetails.Addresses[0].EmailID,
                      "numberofmps":item.NumberOfMPS,
                      "totalshipmentvalues":item.TotalInvoiceValue,
                      "totalphysicalweight":item.totalphysicalweight,
                      "totalvolumetricweight":item.VolumetricWeight,
                      "bookingmode":item.BookingMode,
                      "clientrefnumber":item.ClientReferenceNo,
                      "refnumber":item.referenceno,
                      "dropbyclient":item.isshipmentdroptohubbyclient == 1?1:0,
                      "pickbyclient":item.isselfcollectbyclient == 1?1:0,
                      "ebn":item.ebn,
                      "originhub":originhub,
                      "destinationhubs":destinationhubs,
                      "clienttype": item.clienttype,
                      "clientweightdisabledflag":item.clientweightdisabledflag,
					            "awbcopydata":awbCustomiseData,
                      "enabledimensionvisibilitylrcopy":item.enabledimensionvisibilitylrcopy,
                      "skuboxdimensions": dim,
                      "skuboxquantity": qty,
                      "bookingsource" : item.bookingsource
                    }
                    this.printMultipleAwbs.push(awbdata);
                    let awblogs ={
          						AWBNo: item.parentawb,
          						loggedinhubid : this.hubid,
          						userid : this.userid,
          						useremail : this.useremail,
          						hubName: this.hubname,
          						createdDate:dt,
          						sourceType: "Web"
          					}
          					printMultipleAwbsLogs.push(awblogs);
                    this.validatedawb.push({'awb':item.parentawb});
                  };
                  inputPayload.awblogs=printMultipleAwbsLogs;
				          let  printawblogsresult= Report.printawblogs(inputPayload);
                  this.showdetails = true;
                }else{
                  this.$alert("No Valid AWB(s) details found","","error");
                }
            }else{
              this.$alert("No Valid AWB(s) details found","","error");
            }
            this.isLoading=false;
          }
        }).catch((err) => {
          console.error(err);
          return false;
        });
      }
      catch(err){
        this.$alert(err,"","error");
      }
    },
    async printAWB(){
      this.isLoading=true;
      try {
        const d = new Printd();
        var buffer = '';
        var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
          this.$nextTick(() => {
            d.print(document.getElementById('printMultiple'), cssText);
          })
        this.isLoading=false
      } catch (error) {
        this.isLoading=false
      }
    },
    reset(){
      this.AWBNumber="";
      this.printMultipleAwbs = [];
      this.validatedawb = [];
      this.noofcopies = 1;
      this.showdetails = false;
    }
  },
}

Validator.extend('max_awbnumbers', {
  getMessage: field => "Maximum of 50 AWB(s) you can enter.",
  validate: value => {
    var awbNumbers = $("#AWBNumber").val();
    let awbnumber=awbNumbers.split(/[,]+/);
    if(awbnumber.length>50){
      return false;
    }else{
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/printAWB/printAWB.component.js